<template>
  <div>
    <table class="mgt_tbl">
      <tbody>
        <tr>
          <th>{{ $t("management.documentType") }}</th>
          <th>{{ $t("management.documentName") }}</th>
          <th>{{ $t("management.totalSum") }}</th>
        </tr>
        <tr v-for="(item, index) in data" :key="index">
          <td>
            {{ item.doctypeName }}
          </td>
          <td>
            <a href="#" class="p_l_title text_cursor" style="cursor: none">
              {{ item.docTitle }}
              <!-- <em>
                | {{ item.modelcodeName }} | {{ item.exhaustCertiName }} 
                 | {{ item.modelName }} | {{ item.lang }} |
                {{ item.partNo }} | {{ item.publishedDate }} | v{{ item.versMajor }}.{{
                  item.versMinor
                }}</em
              > -->
            </a>
          </td>
          <td>
            {{ item.sum }}
          </td>
        </tr>
      </tbody>
    </table>
    <div v-if="data.length != 0" class="paging_nav">
      <div class="paging_nav">
        <a
          href="#"
          v-if="pagingVO.startPage <= pagingVO.blockSize"
          class="page_select prev_page disabled"
          >이전페이지 이동</a
        >
        <a
          v-else
          class="page_select prev_page"
          @click="searchPage(pagingVO.startPage - pagingVO.blockSize)"
          v-bind:data-page="pagingVO.startPage - pagingVO.blockSize"
          >이전페이지 이동</a
        >
        <span
          v-for="(pages, index) in pagingVO.endPage - pagingVO.startPage + 1"
          :key="index"
        >
          <strong v-if="pagingVO.startPage + index == pagingVO.currentPage">{{
            pagingVO.startPage + index
          }}</strong>
          <a href="#" v-else @click="searchPage(pagingVO.startPage + index)">{{
            pagingVO.startPage + index
          }}</a>
        </span>
        <a
          v-if="pagingVO.endPage >= pagingVO.totalPage"
          href="#"
          class="page_select next_page disabled"
          >다음페이지 이동</a
        >
        <a
          v-else
          href="#"
          @click="searchPage(pagingVO.endPage + 1)"
          v-bind:data-page="pagingVO.endPage + 1"
          class="page_select next_page"
          >다음페이지 이동</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import { getDocRatioChartData } from "@/api/statistics";

export default {
  components: {},
  data() {
    return {
      title: "Document",
      data: [],
      page: 1,
      pagingVO: "",
      firstDoctype: "",
      firstProdType: "",
      secondProdType: "",
    };
  },
  methods: {
    async getData(firstDoctype, firstProdType, secondProdType) {
      this.firstDoctype = firstDoctype;
      this.firstProdType = firstProdType;
      this.secondProdType = secondProdType;

      await this.fetchData();
    },
    searchPage(page) {
      // 페이지 클릭 시
      this.page = page;
      this.$store.commit("setPage", page);
      this.fetchData();
    },
    async fetchData() {
      let loader = this.$loading.show({});
      try {
        let response = await getDocRatioChartData(
          this.firstDoctype,
          this.firstProdType,
          this.secondProdType,
          this.page
        );
        console.log(response);
        this.$store.commit("setPage", this.page);
        this.data = response.data.pagingVO.dataList;
        this.pagingVO = response.data.pagingVO;
      } finally {
        loader.hide();
      }
    },
  },
};
</script>

<style>
.mgt_tbl {
  width: 100%;
  border-top: 1px solid #333;
  margin-bottom: 0px;
}
.sub_chart_box {
  margin-top: 30px;
}
.paging_nav {
  text-align: center;
  position: relative;
  margin-bottom: 5px;
  margin-top: 5px;
}
</style>
